import { injectable } from 'inversify'
import { SingletonService } from './SingletonService'

@injectable()
export class DefaultSingletonService implements SingletonService {
  getData(): string {
    return 'SingletonService'
  }
}
